"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadOmsPlugin;
var _omsPlugin = _interopRequireDefault(require("./omsPlugin.js"));
/**
 * Loads the OverlappingMarkerSpiderfier plugin for google maps https://github.com/jawj/OverlappingMarkerSpiderfier
 * @returns {OverlappingMarkerSpiderfier}
 */
function loadOmsPlugin() {
  // only load if on client
  if (typeof window !== 'undefined') {
    // if already loaded
    if (window.OverlappingMarkerSpiderfier) {
      return window.OverlappingMarkerSpiderfier;
    }
    _omsPlugin.default.call(window);
    return window.OverlappingMarkerSpiderfier;
  }
}